'use client';

import dynamic from 'next/dynamic';
import { FC, PropsWithChildren } from 'react';
import useCompare from '@/hooks/useCompare';
import CompareFeatureContext from '@/context/CompareFeatureContext';

const CompareAlertDialog = dynamic(() => import('@/containers/CompareFeature/dialog'), { ssr: false });

type CompareFeatureProps = {
  initData: Array<string>;
};

const CompareFeature: FC<PropsWithChildren<CompareFeatureProps>> = ({ children, initData }) => {
  const {
    compareData,
    isSelectedToCompare,
    handleCompare,
    handleRedirectCompare,
    showAlertPopup,
    handleCloseAlertPopup,
  } = useCompare(initData);

  return (
    <CompareFeatureContext.Provider value={{ compareData, isSelectedToCompare, handleCompare, handleRedirectCompare }}>
      {showAlertPopup && (
        <CompareAlertDialog
          handleClose={handleCloseAlertPopup}
          showModal={showAlertPopup}
          handleRedirectCompare={handleRedirectCompare}
        />
      )}
      {children}
    </CompareFeatureContext.Provider>
  );
};

export default CompareFeature;
